import React from 'react';
import moment from 'moment';
import 'moment/locale/ru';
import { FaPlaneArrival, FaPlaneDeparture } from 'react-icons/fa';

function FlightSegment({ flight }) {
  const { number, departure, arrival, company } = flight;
  moment.locale('ru');

  return (
    <div  className="flight">
      <div className="flight__airline">
        <img
          className="flight__airline-logo flight__airline-item"
          alt=""
          src={company?.logo}
        ></img>
        <div className="flight__airline-number flight__airline-item">
          {number}
        </div>
        <div className="flight__airline-name flight__airline-item">
          {company?.name}
        </div>
      </div>
      <div className="flight__to">
        <FaPlaneDeparture className="flight__to-icon" />
        <div className="flight__to-port">
          {departure.port.name ? departure.port.name : 'Аэропорт неизвестен'}
        </div>
        <div className="flight__to-time">
          {moment(departure.date, 'DD.MM.YYYY').format('DD MMM')},{' '}
          {departure.time}
        </div>
      </div>
      <div className="flight__to">
        <FaPlaneArrival className="flight__to-icon" />
        <div className="flight__to-port">
          {arrival.port.name ? arrival.port.name : 'Аэропорт неизвестен'}
        </div>
        <div className="flight__to-time">
          {moment(arrival.date, 'DD.MM.YYYY').format('DD MMM')}, {arrival.time}{' '}
        </div>
      </div>
    </div>
  );
}

export default FlightSegment;
